import { render } from "./ResetPassword.vue?vue&type=template&id=0681a266"
const script = {}
script.render = render

export default script